import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProjectsDto } from '../../../projects/models/project-response.dto';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProjectService } from '../../services/project.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Projeto } from '../../dto/project';
import { PaginationDto } from 'src/app/core/dto/pagination.dto';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjetoFormModalComponent } from '../../../projects/pages/projeto-form-modal/projeto-form-modal.component';
import Swal from 'sweetalert2';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { DocumentsModalComponent } from '../documents-modal/documents-modal.component';
import { AtualizarStatusProjetoComponent } from '../status-projeto/atualizar-status-projeto/atualizar-status-projeto.component';

@Component({
  selector: 'app-client-project',
  templateUrl: './client-project.component.html',
  styleUrl: './client-project.component.scss'
})

export class ClientProjectComponent implements OnInit, OnDestroy {
  @ViewChild('modalComponent') modalComponent!: DocumentsModalComponent;

  projetos: Projeto[] = [];
  paginacao: PaginationDto = {
    paginaAtual: 1,
    quantidadePorPagina: 10,
    totalDeItens: 0,
    ultimaPagina: 0,
  };
  filtroForm: FormGroup;
  isLoading = false;

  private projetosSubscription: Subscription = new Subscription();

  constructor(
    public projectService: ProjectService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
    private toastService: ToastService) {

    this.filtroForm = this.fb.group({
      "PaginaAtual": 1,
      "QuantidadePorPagina": 10,
      Descricao: [""],
      Status: [""],
    });
  }

  ngOnInit(): void {
    this.isLoading = true;

    const filtros = this.projectService.filters;

    this.filtroForm.patchValue({
      "PaginaAtual": filtros["PaginaAtual"],
      "QuantidadePorPagina": filtros["QuantidadePorPagina"],
      Descricao: filtros.Descricao,
      Status: filtros.Status
    });

    this.consultarProjetos();

    this.projetosSubscription = this.filtroForm.valueChanges.subscribe(
      (filters) => {
        //console.log('filtro == ', JSON.stringify(filters));
        this.projectService.setFilters({ ...filters });
      },
    );
  }

  onPageChange(page: number): void {
    this.projectService.setFilters({ "PaginaAtual": page });
  }

  ngOnDestroy(): void {
    // Cancelar a inscrição quando o componente for destruído
    if (this.projetosSubscription) {
      this.projetosSubscription.unsubscribe();
    }

    if (this.projetosSubscription) {
      this.projetosSubscription.unsubscribe();
    }
  }

  
  openNewProject(event?: Projeto): void {
    const clienteId = this.route.snapshot.paramMap.get('id');

    const modalRef = this.modalService.open(ProjetoFormModalComponent, {
      size: 'md',
      backdrop: 'static'
    });
    modalRef.componentInstance.clienteId = clienteId;

    if (event) {
      modalRef.componentInstance.event = event;
    }

    modalRef.closed.subscribe({
      next: (result) => {
        if (result === 'created' || result === 'updated') {
          this.consultarProjetos();
        }
      },
      error: (error) => {
        console.error(error);
      }
    })
  }

  modalAtualizarStatus(event: Projeto): void {
    const modalRef = this.modalService.open(AtualizarStatusProjetoComponent);

    modalRef.componentInstance.projetoId = event.id
    modalRef.componentInstance.statusAtual = event.statusProjeto?.statusProjeto
  }

  consultarProjetos() {
    let clienteId = this.route.snapshot.paramMap.get('id')!;

    this.projetosSubscription = this.projectService.getProjectByClienteId(clienteId).subscribe({
      next: (response) => {
        //console.log(response);
        this.projetos = response.projetos;
        this.paginacao = response.paginacao
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onExcluir(event?: Projeto): void {
    this.cancel(event?.id);
  }

  // Modal personalizada para excluir projeto selecionado
  cancel(projetoId?: string) {

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Continuar Excluindo?',
        text: 'Você não poderá reverter isso! Todos os documentos pertencentem serão escluídos junto.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir',
        cancelButtonText: 'Não, cancelar!'
      })
      .then(result => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Excluído!',
            'Seu item foi excluído.',
            'success'
          );
          this.excluirProjeto(projetoId);
          

        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelado',
            'Seu item continua seguro :)',
            'error'
          );
        }
      });
  }

  excluirProjeto(projetoId?: string): void {
    this.projectService.excluirProjeto(projetoId).subscribe({
      next: (response) => {
        this.toastService.show("Projeto excluído com sucesso!", {
          classname: "bg-success text-light",
        });

        setTimeout(() =>{
          window.location.reload();
        }, 3000)
      },
      error: ((error) => {
        this.toastService.show("Erro ao excluir Projeto!", {
          classname: "bg-danger text-light",
        });
      })
    })
  }

  modalDocumentos(event: Projeto) {
    //console.log('ABRIR MODAL DE LISTA DE DOCUMENTOS', event);
    // Envia o projeto selecionado para a modal documents-modal.component
    const modalRef = this.modalComponent.extraLarge(event.id);
  }

  voltar() {
    this.location.back();
  }

}
